import { createFileRoute } from "@tanstack/react-router";
import { SummaryPage } from "@/plugins/verification/summary-page";

// `$conversationId_`: beside the conversation, not inside it, which renders no outlet.
export const Route = createFileRoute("/_authed/conversations/$conversationId_/zusammenfassung")({
  component: Summary,
});

function Summary() {
  const { conversationId } = Route.useParams();
  return <SummaryPage conversationId={conversationId} />;
}
